import type { ApiResult } from "../types/api";

export class ApiError extends Error {
  readonly code: string;
  readonly status: number;

  constructor(code: string, message: string, status: number) {
    super(message);
    this.code = code;
    this.status = status;
  }
}

export async function apiGet<T>(path: string, token?: string): Promise<T> {
  const response = await fetch(path, {
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    cache: "no-store"
  });

  const payload = (await response.json().catch(() => null)) as ApiResult<T> | null;
  if (!payload) {
    throw new ApiError("invalid_response", "Resposta invalida da API.", response.status);
  }

  if (!payload.ok) {
    throw new ApiError(payload.error.code, payload.error.message, response.status);
  }

  return payload.data;
}

export async function apiSend<TResponse, TBody extends Record<string, unknown>>(
  path: string,
  method: "POST" | "PATCH" | "DELETE",
  body: TBody | null,
  token?: string
): Promise<TResponse> {
  const response = await fetch(path, {
    method,
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      "content-type": "application/json"
    },
    body: body ? JSON.stringify(body) : undefined
  });

  const payload = (await response.json().catch(() => null)) as ApiResult<TResponse> | null;
  if (!payload) {
    throw new ApiError("invalid_response", "Resposta invalida da API.", response.status);
  }
  if (!payload.ok) {
    throw new ApiError(payload.error.code, payload.error.message, response.status);
  }
  return payload.data;
}
